import classnames from "classnames";
import Dropdown from "component/react-bootstrap/Dropdown";
import PropTypes from "prop-types";
import { Component } from "react";
import BreadcrumbDropdownMenu from "./breadcrumb-dropdown-menu.component";
import BreadcrumbDropdownToggle from "./breadcrumb-dropdown-toggle.component";

const propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default class BreadcrumbDropdownItem extends Component {
  constructor(props: any) {
    super(props);

    this.state = { dropdownIsOpen: false };

    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown() {
    const prevDropdownState = this.state.dropdownIsOpen;
    this.setState({ dropdownIsOpen: !prevDropdownState });
  }

  render() {
    const {
      children,

      className,

      id,

      title,
    } = this.props;

    return (
      <Dropdown
        componentClass="li"
        id={id}
        className={classnames("breadcrumb-dropdown-item", className)}
        onToggle={this.toggleDropdown}
        open={this.state.dropdownIsOpen}
      >

        <BreadcrumbDropdownToggle bsRole="toggle" open={this.state.dropdownIsOpen}>

          <div className="title">
            {title}
          </div>
        </BreadcrumbDropdownToggle>

        <BreadcrumbDropdownMenu onClick={this.toggleDropdown} bsRole="menu">

          { this.state.dropdownIsOpen && children}
        </BreadcrumbDropdownMenu>
      </Dropdown>
    );
  }
}

BreadcrumbDropdownItem.propTypes = propTypes;
